import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { defineStore } from 'pinia';
import { ElMessage } from 'element-plus';
import { findLast } from 'lodash-es';
import useAppStore from '@views/app.store';
import { nanoid } from 'nanoid';
import { getMessageList, assessSessionDetail, confirmKnowledge, updateMessageStatus, addUnConfirmKnowledgeReason } from './api';
export { storeToRefs } from 'pinia';
export default defineStore('main', () => {
  const appStore = useAppStore();
  const loading = ref(false);
  const conversationList = ref([]); // 会话列表
  const isDialogue = ref(false); // 是否处于对话交互状态，避免websocket 对话消息冲突
  const toBeSyncList = ref({}); // 待同步消息列表,在对话消息期间如果出现了新的消息
  const incrementalMessageList = ref({}); // 增量消息列表
  const componentFunMap = ref(new Map()); // 组件方法集合
  const incrementIns = ref(0); // 消息队列自增索引
  const fold = ref(false); // 侧边栏折叠状态
  const messageContentMap = ref({}); // 消息内容映射
  const sessionDetail = ref({}); // 会话详情
  const msgParams = reactive({
    sessionId: '',
    cursor: 0,
    limit: 10,
    hasMore: true
  });
  const lastMsgId = computed(() => {
    // v1.2.0增加逻辑,用于触发禁用会话的编辑操作
    if (sessionDetail.value?.conversationType === 3) {
      return '-1';
    }
    const len = conversationList.value.length;
    return conversationList.value[len - 1]?.id || '';
  });
  const lastFileMsgId = computed(() => {
    // v1.2.0增加逻辑,用于触发禁用会话的编辑操作
    if (sessionDetail.value?.conversationType === 3) {
      return '-1';
    }
    const lastFileMsg = findLast(conversationList.value, item => item.messageType === 105 || item.messageType === 305);
    if (lastFileMsg) {
      return lastFileMsg.id;
    }
    // 新建关键词时
    return findLast(conversationList.value, item => item.messageType === 103 || item.messageType === 303)?.id || '';
  });
  // 设置是否处于对话状态
  function setIsDialogue(val) {
    isDialogue.value = val;
  }
  // 获取会话列表
  function getConversationList(obj) {
    const params = {
      sessionId: msgParams.sessionId,
      cursor: msgParams.cursor || 0,
      limit: msgParams.limit
    };
    if (obj) Object.assign(params, obj);
    loading.value = true;
    return getMessageList(params).then(res => {
      msgParams.hasMore = res.data.hasMore;
      msgParams.cursor = res.data.cursor;
      // 记录初始自增索引
      const list = res.data.list || [];
      Object.assign(messageContentMap.value, res.data.messageContentMap);
      let bol = true;
      list.forEach((item, index) => {
        const prevItem = list[index + 1];
        let nextItem = list[index - 1];
        if (index === 0 && conversationList.value.length) {
          const lastItem = conversationList.value[conversationList.value.length - 1];
          // eslint-disable-next-line no-use-before-define
          nextItem = getLastMsgId(lastItem, toBeSyncList.value);
        }
        let content = null;
        try {
          content = JSON.parse(item.content);
        } catch {
          content = item.content;
        }
        // 设置消息映射的初始化增量消息,保证消息指向没有问题
        if (!messageContentMap.value[item.id]) {
          messageContentMap.value[item.id] = [];
        }
        const msgItem = {
          ...item,
          content,
          prevId: prevItem?.id || null,
          nextId: nextItem?.id || null,
          openAnimate: item.type === 2 && Boolean(item.openAnimate)
        };
        if (params.cursor === 0 && msgItem.openAnimate && bol) {
          toBeSyncList.value[msgItem.id] = msgItem;
        } else {
          bol = false;
          msgItem.openAnimate = false;
          conversationList.value.unshift(msgItem);
        }
      });
      if (!conversationList.value.length) {
        const lastItem = res.data.list[res.data.list.length - 1];
        conversationList.value.push(toBeSyncList.value[lastItem.id]);
      }
      if (params.cursor === 0) {
        const lastItem = conversationList.value[conversationList.value.length - 1];
        if (lastItem && !lastItem.openAnimate) {
          // eslint-disable-next-line no-use-before-define
          loadNextMsg(lastItem);
        }
      }
    }).catch(err => {
      loading.value = false;
    }).finally(() => {
      loading.value = false;
    });
  }
  // 处理回复消息后续机制
  function loadNextMsg(item) {
    const flushNext = () => {
      if (item.nextId && toBeSyncList.value[item.nextId]) {
        const newMsg = toBeSyncList.value[item.nextId];
        newMsg.newLoad = true;
        conversationList.value.push(newMsg);
        delete toBeSyncList.value[item.nextId];
      }
    };
    if (item.openAnimate) {
      updateMessageStatus(item.id).then(() => {
        const index = conversationList.value.findIndex(o => o.id === item.id);
        const msgItem = conversationList.value[index];
        conversationList.value.splice(index, 1, {
          ...msgItem,
          openAnimate: false
        });
        // 状态确认完成后再尝试出队：处理"loadNextMsg 触发时 next 消息尚未到达，随后到达但因 openAnimate 未翻转而卡住"的场景
        flushNext();
      });
    }
    flushNext();
    if (item.messageType === 110) {
      componentFunMap.value.get('main_sendAction')('opinion', item);
    }
  }
  // 处理用户意见
  async function handleOpinion(bol, val, info) {
    if (bol) {
      // 动作的时候必须有信息
      const {
        content
      } = info;
      const obj = JSON.parse(content);
      await addUnConfirmKnowledgeReason({
        knowledgeIds: obj.knowledgeIds,
        sessionId: msgParams.sessionId,
        reason: val
      });
      ElMessage.success('感谢您的宝贵意见！稍后会根据您的建议进行方案改进,重新为您推送知识库');
    }
  }
  // 处理知识确认 后续机制
  async function handleKeywordSure(wordAndFile, status = 1) {
    if (wordAndFile) {
      const knowledgeIds = wordAndFile.reduce((pre, cur) => {
        pre.push(...cur.attachmentDetails.map(item => item.knowledgeId));
        return pre;
      }, []);
      const params = {
        knowledgeIds,
        sessionId: msgParams.sessionId,
        status,
        tips: status === 1 ? '我选择了这部分的知识内容' : '对分析结果不满意'
      };
      await confirmKnowledge(params);
    }
  }
  const messageTypeArr = [30015, 30016, 30017, 20003, 20004, 20005, 20006, 20007,
  // 网站GEO分析 INC子节点
  60201, 60202, 60203, 60204, 60301, 60302, 60303, 60304, 60305, 60306, 60401, 60402, 60501];
  // 暂存尚未关联到父级消息的增量消息，按父级消息id分组
  const pendingIncrementalMessages = ref({});
  const handleIncrementalMessage = message => {
    const messageItem = conversationList.value.find(o => o.id === message.id);
    if (messageItem && componentFunMap.value.get(message.id)) {
      componentFunMap.value.get(message.id)(message);
      return;
    }
    let incrementalItem = conversationList.value.find(x => x.id === message.id);
    if (!incrementalItem) incrementalItem = toBeSyncList.value[message.id];
    if (incrementalItem) {
      const incrementalIds = incrementalItem.incrementalIds || [];
      const id = nanoid();
      incrementalIds.push(id);
      incrementalItem.incrementalIds = incrementalIds;
      incrementalMessageList.value[id] = message;
    } else {
      // 父级消息尚未到达，暂存增量消息，等父级消息到达后再关联
      if (!pendingIncrementalMessages.value[message.id]) {
        pendingIncrementalMessages.value[message.id] = [];
      }
      pendingIncrementalMessages.value[message.id].push(message);
    }
  };
  const watchLoading = () => {
    return new Promise(resolve => {
      const timer = setInterval(() => {
        if (!loading.value) {
          clearInterval(timer);
          resolve(true);
        }
      }, 100);
    });
  };
  async function handleWsConversation(info) {
    const {
      sessionId
    } = info;
    if (sessionId !== msgParams.sessionId) {
      return;
    }
    // 等待历史列表消息处理完毕
    await watchLoading();
    if (messageTypeArr.includes(info.message.messageType)) {
      handleIncrementalMessage(info.message);
      return;
    }
    const message = info.message;
    if (message.messageType === 99999) {
      appStore.getAssessResidualEquityNum();
      return;
    }
    // 同 id 消息 = 父级步骤的完成/更新通知（如 602 executeStatus=3），原地更新已有条目
    // 注意：保留原 openAnimate 语义，交由组件自己在 tryLoadNext 满足条件时调 loadNextMsg 置 false 并 flush 队列
    const parsedContent = typeof message.content === 'string' ? JSON.parse(message.content) : message.content;
    const existingIndex = conversationList.value.findIndex(o => o.id === message.id);
    if (existingIndex > -1) {
      const existing = conversationList.value[existingIndex];
      conversationList.value.splice(existingIndex, 1, {
        ...existing,
        content: parsedContent
      });
      return;
    }
    if (toBeSyncList.value[message.id]) {
      const existing = toBeSyncList.value[message.id];
      toBeSyncList.value[message.id] = {
        ...existing,
        content: parsedContent
      };
      return;
    }
    let lastItem = conversationList.value.at(-1);
    if (!lastItem) return;
    let bol = lastItem.openAnimate;
    if (lastItem.nextId) {
      bol = true;
      // eslint-disable-next-line no-use-before-define
      lastItem = toBeSyncList.value[getLastMsgId(lastItem, toBeSyncList.value)];
    }
    lastItem.nextId = message.id;
    const obj = {
      ...message,
      content: parsedContent,
      prevId: lastItem?.id || null,
      nextId: null,
      openAnimate: Boolean(message.openAnimate)
    };
    if (bol) {
      toBeSyncList.value[obj.id] = obj;
    } else {
      conversationList.value.push(obj);
    }
    // 检查是否有暂存的增量消息需要关联到这条新消息（GEO场景）
    const pendingMsgs = pendingIncrementalMessages.value[obj.id];
    if (pendingMsgs && pendingMsgs.length > 0) {
      obj.incrementalIds = obj.incrementalIds || [];
      pendingMsgs.forEach(pendingMsg => {
        const incId = nanoid();
        obj.incrementalIds.push(incId);
        incrementalMessageList.value[incId] = pendingMsg;
      });
      delete pendingIncrementalMessages.value[obj.id];
    }
  }
  function init() {
    conversationList.value.splice(0, conversationList.value.length);
    isDialogue.value = false;
    toBeSyncList.value = {};
    incrementalMessageList.value = {};
    pendingIncrementalMessages.value = {};
    messageContentMap.value = {};
    componentFunMap.value.clear();
    incrementIns.value = 0;
    msgParams.sessionId = '';
    msgParams.cursor = 0;
    msgParams.limit = 10;
    msgParams.hasMore = true;
  }
  // 切换折叠状态
  function toggleFold() {
    fold.value = !fold.value;
  }
  // 会话详情
  watch(() => msgParams.sessionId, async newVal => {
    if (newVal) {
      try {
        const {
          data
        } = await assessSessionDetail({
          sessionId: newVal
        });
        sessionDetail.value = data;
      } catch (error) {
        console.log(error);
      }
    } else {
      sessionDetail.value = {};
    }
  });
  return {
    loading,
    lastMsgId,
    lastFileMsgId,
    isDialogue,
    conversationList,
    messageContentMap,
    incrementalMessageList,
    msgParams,
    componentFunMap,
    fold,
    setIsDialogue,
    getConversationList,
    loadNextMsg,
    handleOpinion,
    handleKeywordSure,
    handleWsConversation,
    init,
    toggleFold,
    sessionDetail
  };
});
function getLastMsgId(item, obj) {
  if (!item.nextId) return item.id;
  return getLastMsgId(obj[item.nextId], obj);
}